/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
*   Amina Rais - Massive Improvements
 * Version: 2.0.0
 *
 *******************************************************************************/

import React, { useEffect } from 'react';
import { Grid } from '@mui/material';
import PageHeader from './PageHeader';
import PageFooter from './PageFooter';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import MenuSideBar from './MenuSideBar';
import { BrowserView, isMobile } from 'react-device-detect';
import { getUserInfo } from '../../store/reducers/user/userAction';
import { initializedSuccess } from '../../store/reducers/initialized/initializedSlice';
import { useCallback } from 'react';
import { IMAGES } from '../../config/assets';




const Layout = ({ ...props }) => {
  const navigate = useNavigate();
  const loginned = useSelector(state => state.user.loginned)
  const dispatch = useDispatch()
  const location = useLocation()


  /**
 * Get auth object from local storage
 */

  const getAuth = () => {
    const authData = localStorage.getItem('getchkdjwt');
    return authData ? JSON.parse(authData)?.token : null;
  };
  const initializeApp = useCallback(async () => {
    const auth = getAuth();
    if (!auth) {
      if (!['/login', '/tos', '/privacypolicy', '/contact-us', '/about-us'].includes(location.pathname) && !location.pathname.includes('/register')) {
        navigate('/login');
      }
    } else {
      if (!loginned) {
        try {
          await dispatch(getUserInfo()).unwrap();
          if (['/', '/login', '/register'].includes(location.pathname)) {
            navigate('/dashboard');
          }
          dispatch(initializedSuccess());
        } catch (error) {
          navigate('/login');
          localStorage.clear();
          window.location.reload();
        }
      } else {
        if (['/', '/login', '/register'].includes(location.pathname)) {
          navigate('/dashboard');
        }
        dispatch(initializedSuccess());
      }
    }
  }, [dispatch, location, navigate, loginned]);

  useEffect(() => {
    initializeApp();
  }, [initializeApp])
  const { children } = props;
  const { classes } = useStyles();

  // Define pages where the Drawer should not appear
  const noDrawerPages = ["/about-us", "/tos", "/privacypolicy", "/contact-us"];

  return (
    <div className={classes.layout}>
      <PageHeader />
      <main className={classes.main}  style={{ marginLeft: isMobile || noDrawerPages.includes(location.pathname) ? '0px' : '80px' }}>
        <BrowserView>
          {/* Conditionally render MenuSideBar */}
          {loginned && !noDrawerPages.includes(location.pathname) && <MenuSideBar style={{ marginLeft: isMobile ? '0px' : '80px' }} />}
        </BrowserView>
        <Grid container justify="center">
          <Grid container className={classes.gridInner}>
            <Grid item xs={12} className={classes.maxWidthDiv}>
              {children}
            </Grid>
          </Grid>
        </Grid>
      </main>
      <PageFooter />
    </div>
  );
};

const useStyles = makeStyles({ "name": { Layout } })((theme) => ({
  layout: {
    display: 'flex',
    minHeight: '100vh',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.grayed,
    backgroundImage: `url(${IMAGES.WHITE_BACKGROUND})`,
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    backgroundAttachment: 'fixed',
  },
  main: {
    flex: 1,
    marginBottom: '10px',
  },
  gridInner: {
    maxWidth: '100%',
  },
  maxWidthDiv: {
    width: '100%',
  },
}));

export default Layout;